import { LOCALES } from '../../../server/src/shared/locales';
import { Locale } from '../messages';

export const DEFAULT_LOCALE: Locale = 'cs';

// Sourced from the server so that the locales an admin can set are exactly the ones we can render.
export const SUPPORTED_LOCALES: Locale[] = [...LOCALES];

export const LOCALE_LABELS: Record<Locale, string> = {
	cs: 'Čeština',
	en: 'English',
};

const STORAGE_KEY = 'locale';

export const isLocale = (value: unknown): value is Locale =>
	typeof value === 'string' && (SUPPORTED_LOCALES as string[]).includes(value);

// e.g. "en-US" -> "en"
export const detectBrowserLocale = (): Locale => {
	const lang = navigator.language?.slice(0, 2).toLowerCase();
	return isLocale(lang) ? lang : DEFAULT_LOCALE;
};

export const getStoredLocale = (): Locale | null => {
	const stored = localStorage.getItem(STORAGE_KEY);
	return isLocale(stored) ? stored : null;
};

export const setStoredLocale = (locale: Locale) => {
	localStorage.setItem(STORAGE_KEY, locale);
};
